// extracted by mini-css-extract-plugin
export var bodyContainer = "articleMeta-module--bodyContainer--b7279";
export var divider = "articleMeta-module--divider--489e6";
export var fullWidth = "articleMeta-module--fullWidth--22070";
export var readtime = "articleMeta-module--readtime--44411";
export var topicIcon = "articleMeta-module--topicIcon--e0ff1";
export var topicTitleContainer = "articleMeta-module--topicTitleContainer--2f392";